import axios from 'axios';
var tokenID = '';
var init = function init() {
  axios.defaults.headers.common['token'] = tokenID;
  axios.defaults.baseURL = 'https://api.musubi-thai.com/api/v1.0/';
};
// const init2 = () => {
//   axios.defaults.headers.common['token'] = tokenID
//   axios.defaults.headers.post['Content-Type'] = 'text/plain'
//   axios.defaults.baseURL = 'https://api2.musubi-thai.com/api/v1/'
// }
var statusError = function statusError(error) {
  return {
    data: error.response.data,
    status: error.response.status,
    statusText: error.response.statusText,
    message: error.response.data.message
  };
};
var statusNotImplemented = function statusNotImplemented() {
  return {
    status: 501,
    statusText: 'Not implement',
    message: 'Please Debug'
  };
};
var replaceUrl = function replaceUrl(url) {
  if (url.substr(-1) === '/') {
    return url.slice(0, -1);
  } else {
    return url;
  }
};
var get = function get(url, param) {
  url = replaceUrl(url);
  var res4 = axios.get(url, {
    params: param
  }).catch(function (error) {
    if (error.response) {
      // console.log(error.response)

      return statusError(error);
    }
    return statusNotImplemented();
  });
  return res4;
};

var post = function post(url, param, onProgress) {
  url = replaceUrl(url);
  var config = {
    onUploadProgress: function onUploadProgress(progressEvent) {
      var percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
      // execute the callback
      if (onProgress) {
        onProgress(percentCompleted);
      }
      return percentCompleted;
    }
  };
  return axios.post(url, param, config).then(function (response) {
    return response;
  }).catch(function (error) {
    if (error.response) {
      return statusError(error);
    }
    return statusNotImplemented();
  });
};
var put = function put(url, param) {
  url = replaceUrl(url);
  var resPut = axios.put(url, param).then(function (response) {
    return response;
  }).catch(function (error) {
    if (error.response) {
      // statusError(error)
      return statusError(error);
    }

    return statusNotImplemented();
  });
  return resPut;
};
var listAllProject = function listAllProject(query) {
  return get('projects/', query);
};
var getProject = function getProject(id) {
  init();
  return get('projects/' + id);
};
var readTask = function readTask(id) {
  init();
  return put('notification/task/read/' + id);
};
var getMessage = function getMessage(id) {
  init();
  return get('inbox/' + id);
};
var sendMessage = function sendMessage(message) {
  init();
  return post('inbox/', message);
};
var loadNotification = function loadNotification(userID) {
  init();
  return get('inbox/notification');
};
var readMessage = function readMessage(id) {
  init();
  return put('inbox/read/' + id);
};

var login = function login(userID, password, roleID) {
  init();
  var aUser = post('/account/login/', {
    userID: userID,
    password: password,
    role: roleID
  });
  return aUser;
};
var Accept = function Accept(projectID) {
  init();
  return put('projects/' + projectID + '/accepts/');
};
var Acknowledge = function Acknowledge(id) {
  init();
  return put('projects/' + id + '/knowledges/');
};
var resetQuotation = function resetQuotation(id) {
  init();
  return put('projects/' + id + '/resetquotation/');
};
var showAllUser = function showAllUser(query) {
  init();
  return get('members/roles/user/', query);
};
var showAllCustomer = function showAllCustomer(keyword) {
  init();
  return get('members/roles/customer/', keyword);
};
var showPersonAssign = function showPersonAssign(keyword) {
  init();
  return get('members/assign/', {
    keyword: keyword
  });
};
var showAllEngineer = function showAllEngineer(query) {
  init();
  return get('/members/roles/engineer/', query);
};
var showAllPartner = function showAllPartner(keyword) {
  init();
  return get('members/roles/partner/', keyword);
};
var listPartner = function listPartner(keyword) {
  init();
  return get('projects/listpartner');
};
var getProfile = function getProfile(id) {
  init();
  return get('members/' + id);
};
var getDashboard = function getDashboard(userID) {
  init();
  return get('members/' + userID + '/dashboard/');
};
var listTaskOfProject = function listTaskOfProject(id) {
  init();
  return get('/projects/' + id + '/tasks');
};
var taskNotRead = function taskNotRead(query) {
  init();

  return get('/projects/task/notread', query);
};
var sendEmailToPartner = function sendEmailToPartner(prodTaskID) {
  init();
  return post('/projects/task/' + prodTaskID + '/re-send');
};
var remindProject = function remindProject(param) {
  init();
  return get('/projects/remind', param);
};
var sendRemindProject = function sendRemindProject(params) {
  init();
  return post('/projects/' + params.projectID + '/send-remind', params);
};
var setRemindProject = function setRemindProject(projectID, params) {
  init();
  return put('/projects/' + projectID + '/reminds', params);
};
var listFileOrProject = function listFileOrProject(id) {
  init();
  return get('/projects/' + id + '/files');
};
var createProject = function createProject(dataModel, onProgress) {
  init();
  // do some
  // console.log(onProgress)
  return post('projects/create', dataModel, onProgress);
};
var uploadQuotationTask = function uploadQuotationTask(projectID, prodTaskID, dataModel) {
  init();
  return put('projects/' + projectID + '/tasks/' + prodTaskID + '/upload', dataModel);
};
var updateCurrentEst = function updateCurrentEst(projectID, prodTaskID, dataModel) {
  init();
  // console.log(dataModel)

  return put('projects/' + projectID + '/tasks/' + prodTaskID + '/currentDeliveryDate', dataModel);
};
var uploadChat = function uploadChat(dataModel, progress) {
  init();
  return post('projects/uploadchat', dataModel, progress);
};
var createProdTask = function createProdTask(projectID, dataModel) {
  init();
  dataModel.isFinal = 'No';
  return post('projects/' + projectID + '/tasks/create', dataModel);
};
var getTaskDetail = function getTaskDetail(id) {
  init();
  return get('projects/P18-00053/tasks/' + id);
};
var listFinalTask = function listFinalTask(projectID) {
  init();
  return get('projects/' + projectID + '/finals/');
};
var listTaskVendor = function listTaskVendor(query) {
  init();
  return get('projects/showtask/vendor/', query);
};
var putTaskToFinal = function putTaskToFinal(prodTaskID) {
  init();
  return put('projects/tasks/' + prodTaskID + '/finals');
};
var putTaskLeadTime = function putTaskLeadTime(prodTaskID, leadTime) {
  init();
  return put('projects/tasks/leadTime', {
    prodTaskID: prodTaskID,
    leadTime: leadTime
  });
};
var putDeliveryDate = function putDeliveryDate(projectID, prodTaskID, deliveryDate) {
  init();
  return put('projects/' + projectID + '/tasks/deliverydate', {
    prodTaskID: prodTaskID,
    deliveryDate: deliveryDate
  });
};
var acceptTask = function acceptTask(projectID, prodTaskID) {
  init();
  return put('projects/' + projectID + '/tasks/' + prodTaskID + '/accept', {
    prodTaskID: prodTaskID
  });
};
var rollBackQU = function rollBackQU(projectID) {
  init();
  return put('');
};
var acceptTaskFromAdmin = function acceptTaskFromAdmin(projectID, prodTaskID) {
  init();
  return put('projects/' + projectID + '/tasks/' + prodTaskID + '/confirm', {
    prodTaskID: prodTaskID
  });
};
var completeTaskFromAdmin = function completeTaskFromAdmin(prodTaskID) {
  init();
  return put('tasks/' + prodTaskID + '/completed');
};
var rejectTask = function rejectTask(projectID, prodTaskID, remark) {
  init();
  return put('projects/' + projectID + '/tasks/' + prodTaskID + '/reject', {
    remark: remark
  });
};
var GetFinalTask = function GetFinalTask(projectID) {
  init();
  return get('/projects/' + projectID + '/finals/');
};
var UpdateActualTask = function UpdateActualTask(quNo, reivseNo, jsonData) {
  init();
  return put('/quotation/' + quNo + '/revise/' + reivseNo + '/actual/', jsonData);
};
var GetRevise = function GetRevise(quno) {
  init();
  return get('/quotation/' + quno + '/revise');
};
var GetDataFromRevise = function GetDataFromRevise(quno, revise) {
  init();
  return get('/quotation/' + quno + '/revise/' + revise);
};
var CreateNewQU = function CreateNewQU(jsonData, projectID) {
  init();
  return post('/quotation/' + projectID + '/create', jsonData);
};
var CreateNewQUFromRevise = function CreateNewQUFromRevise(jsonData, projectID, quno, revise) {
  init();
  return post('/projects/' + projectID + '/quotation/' + quno + '/revise/' + revise + '/create', jsonData);
};
var GetQUOfProject = function GetQUOfProject(projectID) {
  init();
  return get('/quotation/project/' + projectID + '/');
};
var AcceptQU = function AcceptQU(quNo, revise) {
  init();
  return put('/quotation/' + quNo + '/revise/' + revise);
};
var GetLastQU = function GetLastQU(projectID) {
  init();
  return get('/quotation/' + projectID + '/accept');
};
var ListAllTask = function ListAllTask(query) {
  init();
  // console.log(query)
  return get('tasks/', query);
};
var CompleteProject = function CompleteProject(projectID, params) {
  init();
  return put('/projects/' + projectID + '/complete', params);
};
var assignJob = function assignJob(projectID, jobNo) {
  init();
  return put('projects/' + projectID + '/jobNumbers', {
    jobNumber: jobNo
  });
};
var GetEngineerOfProject = function GetEngineerOfProject(projectID) {
  init();
  return get('projects/' + projectID + '/engineer');
};
var getPersonInProject = function getPersonInProject(projectID) {
  init();
  return get('projects/' + projectID + '/person');
};
var getPersonInProtTask = function getPersonInProtTask(projectID, taskID) {
  init();

  return get('projects/' + projectID + '/tasks/' + taskID + '/person');
};
var AssignEngineer = function AssignEngineer(jsonData) {
  init();
  return post('projects/engineer/assign', jsonData);
};
var ShowAllTask = function ShowAllTask() {
  init();
  return get('/tasks/');
};
var DeleteProject = function DeleteProject(projectID, remark) {
  init();
  return put('/projects/' + projectID + '/Delete', {
    deleteRemark: remark
  });
};
var CancelProject = function CancelProject(projectID, remark) {
  init();
  return put('/projects/' + projectID + '/Cancel', {
    deleteRemark: remark
  });
};

var EmailSetting = function EmailSetting(mailList) {
  init();
  return put('/projects/mail-setting/', mailList);
};
var ReadEmailSetting = function ReadEmailSetting() {
  init();
  return get('/projects/mail-setting/');
};
var UploadPOCustomer = function UploadPOCustomer(projectID, formData) {
  init();
  return put('/projects/' + projectID + '/uploadpo', formData);
};
var UploadPOMusubi = function UploadPOMusubi(projectID, prodTaskID, formData) {
  init();
  return put('/projects/' + projectID + '/tasks/' + prodTaskID + '/uploadpo', formData);
};
var CreateMember = function CreateMember(userData) {
  init();
  return post('/members/create', userData);
};
var GetUser = function GetUser(userID) {
  init();
  return get('members/' + userID);
};
var UpdateMember = function UpdateMember(userData) {
  init();
  return put('members/update', userData);
};
var GetPassToken = function GetPassToken(email, tokenID) {
  return put('members/password-token', {
    email: email,
    token: tokenID
  });
};
var RequestPassword = function RequestPassword(email) {
  init();
  return put('members/request-newpassword', {
    email: email
  });
};
var ResetPassword = function ResetPassword(userData) {
  init();
  return put('members/reset-password', userData);
};
var ChangePassword = function ChangePassword(userData) {
  init();
  return put('members/change-password', userData);
};
var AdminCreate = function AdminCreate(userData) {
  init();
  return post('/members/create', userData);
};
var uploadAvatar = function uploadAvatar(params) {
  init();
  return put('/members/uploadAvatar', params);
};
var EditTask = function EditTask(data) {
  init();
  return put('/projects/' + data.projectID + '/tasks/' + data.prodTaskID + '/update/', data);
};
var EditProject = function EditProject(data, projectID) {
  init();
  return put('/projects/' + projectID + '/update/', data);
};
var exportData = {
  CancelProject: CancelProject,
  EditProject: EditProject,
  EditTask: EditTask,
  uploadAvatar: uploadAvatar,
  AdminCreate: AdminCreate,
  ChangePassword: ChangePassword,
  ResetPassword: ResetPassword,
  RequestPassword: RequestPassword,
  GetPassToken: GetPassToken,
  UpdateMember: UpdateMember,
  CreateMember: CreateMember,
  GetUser: GetUser,
  UploadPOMusubi: UploadPOMusubi,
  UploadPOCustomer: UploadPOCustomer,
  rollBackQU: rollBackQU,
  ReadEmailSetting: ReadEmailSetting,
  EmailSetting: EmailSetting,
  ShowAllTask: ShowAllTask,
  AssignEngineer: AssignEngineer,
  GetEngineerOfProject: GetEngineerOfProject,
  CompleteProject: CompleteProject,
  ListAllTask: ListAllTask,
  AcceptQU: AcceptQU,
  GetLastQU: GetLastQU,
  sendRemindProject: sendRemindProject,
  setRemindProject: setRemindProject,
  token: '',
  getToken: function getToken() {},
  setToken: function setToken(token) {
    tokenID = token;
  },

  GetQUOfProject: GetQUOfProject,
  UpdateActualTask: UpdateActualTask,
  listAllProject: listAllProject,
  getProject: getProject,
  login: login,
  CreateNewQU: CreateNewQU,
  CreateNewQUFromRevise: CreateNewQUFromRevise,
  GetRevise: GetRevise,
  GetDataFromRevise: GetDataFromRevise,
  acknowledge: Acknowledge,
  showAllUser: showAllUser,
  showAllCustomer: showAllCustomer,
  showAllEngineer: showAllEngineer,
  showAllPartner: showAllPartner,
  getProfile: getProfile,
  GetFinalTask: GetFinalTask,
  assignJob: assignJob,
  getPersonInProject: getPersonInProject,
  getDashboard: getDashboard,
  listTaskOfProject: listTaskOfProject,
  Accept: Accept,
  uploadChat: uploadChat,
  createProdTask: createProdTask,
  getTaskDetail: getTaskDetail,
  listFinalTask: listFinalTask,
  listTaskVendor: listTaskVendor,
  putTaskToFinal: putTaskToFinal,
  createProject: createProject,
  putTaskLeadTime: putTaskLeadTime,
  putDeliveryDate: putDeliveryDate,
  acceptTask: acceptTask,
  rejectTask: rejectTask,
  uploadQuotationTask: uploadQuotationTask,
  acceptTaskFromAdmin: acceptTaskFromAdmin,
  DeleteProject: DeleteProject,
  listFileOrProject: listFileOrProject,
  getMessage: getMessage,
  remindProject: remindProject,
  taskNotRead: taskNotRead,
  sendEmailToPartner: sendEmailToPartner,
  readTask: readTask,
  resetQuotation: resetQuotation,
  sendMessage: sendMessage,
  loadNotification: loadNotification,
  readMessage: readMessage,
  getPersonInProtTask: getPersonInProtTask,
  listPartner: listPartner,
  showPersonAssign: showPersonAssign,
  updateCurrentEst: updateCurrentEst,
  completeTaskFromAdmin: completeTaskFromAdmin
};
export default exportData;


//////////////////
// WEBPACK FOOTER
// ./api/api.js
// module id = ./api/api.js
// module chunks = 82